import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [];

  return { tableColumns };
};
export default configTable;
